<template>
  <div :class="classes"></div>
</template>
<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { default as IO } from './_source/heapIo'
  import meituanIM from '@/module/apis/meituanIM'
  import WS from '@/module/components/mtIm/_source/ws'
  import { mtIMWsHanlder } from '@/module/components/mtIm/_source/utils'

  const prefixCls = 'vi-mt-im'
  export default {
    name: 'vi-mt-im',
    data () {
      return {
        cacheIMWebsocket: []
      }
    },
    props: {},
    methods: {
      ...mapActions('meituanIM', ['getStoreData']),
      ...mapMutations('meituanIM', ['setIMWebsocket', 'setCacheAppSecret']),
      getAuthorizedStore () {
        const self = this
        meituanIM.getAuthorizedStore({ currentPage: 1, pageSize: 500, platformCode: '27' }).then(res => {
          // 缓存密钥
          this.setCacheAppSecret(res.data)

          _.map(res.data, v => {
            const { appSecret, appId } = v
            IO(() => meituanIM.getMeituanToken({ appSecret, appId }), (po) => {
              po.then((res) => {
                if (res) {
                  const { appkey, connectionToken } = res

                  // 存储聊天信息
                  self.setIMWebsocket({ key: appkey, value: new WS({ appId: appkey, token: connectionToken }).IMConnect() })

                  // 监听聊天等信息
                  mtIMWsHanlder(appkey, self.$root)
                }
              }).catch(e => {
                self.$message.error(e.msg)
                console.log(e.msg + '--' + v.id)
              })
            }, v.id)
          })
        })
      },
      async getData () {
        // 获取门店数据
        await this.getStoreData()
        // 获取聊天用户
        await this.getAuthorizedStore()
      }
    },
    watch: {},
    beforeCreate () {
    },
    created () {
      this.getData()
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('meituanIM', ['IMWebsocket']),
      classes () {
        return [
          `${prefixCls}`
        ]
      }
    },
    components: {}
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "vi-mt-im";
  .#{$-prefix-cls} {
  }
</style>



// WEBPACK FOOTER //
// src/js/module/components/mtIm/mtIm.vue